import React from "react";
import { motion } from "framer-motion";

// Reusable scroll-reveal wrapper: fades + eases up as it enters the viewport.
export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", once = true }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
